export default "__VITE_ASSET__CD_iXZP7__"